import ApiService from '@/services/core/api.service'

const DashboardService = {
  async getStatistics () {
    return ApiService.get('logistics-officer/dashboard/statistics')
  }
}

export default DashboardService
